import { createFeature, createReducer, on } from '@ngrx/store';

import { Locations } from 'app/shared/features/location-selector/models';

import { updateLocations } from './locations.actions';

export const locationsFeatureKey = 'locations';

export interface LocationsState {
    locations: Locations[];
}

export const initialState: LocationsState = {
    locations: [],
};

export const reducer = createReducer(
    initialState,
    on(updateLocations, (state, { locations }) => {
        const currentJson = JSON.stringify(state.locations.sort(compareByAlphaNumericName));
        const newJson = JSON.stringify(locations.sort(compareByAlphaNumericName));
        const listChanged = currentJson !== newJson;
        return listChanged ? { ...state, locations: [...locations] } : state;
    }),
);

export const LocationsReducer = createFeature({ name: locationsFeatureKey, reducer });

function compareByAlphaNumericName(a: Locations, b: Locations) {
    return a.name.localeCompare(b.name, 'en', { numeric: true });
}
